import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Login } from '@/pages/Login';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { ResetPassword } from '@/pages/ResetPassword';
import { AdminVocabulary } from '@/pages/AdminVocabulary';
import { Dashboard } from '@/pages/Dashboard/Dashboard';
import { Perfil } from '@/pages/Perfil/Perfil';
import { Reservas } from '@/pages/Reservas';
import { Disponibilidad } from '@/pages/Disponibilidad';
import { AdminUsuarios } from '@/pages/AdminUsuarios';
import { ModulesList } from '@/pages/Lecciones/ModulesList';
import { ModuleDetail } from '@/pages/Lecciones/ModuleDetail';
import { LessonDetail } from '@/pages/Lecciones/LessonDetail';
import { GrammarBankArchive } from '@/pages/GrammarBank/GrammarBankArchive';
import { GrammarBankDetail } from '@/pages/GrammarBank/GrammarBankDetail';
import { MisFeedbacks } from '@/pages/MisFeedbacks/MisFeedbacks';
import { FeedbackDetail } from '@/pages/MisFeedbacks/FeedbackDetail';
import { ProfeFeedbacks } from '@/pages/ProfeFeedbacks/ProfeFeedbacks';
import { MisNotas } from '@/pages/MisNotas/MisNotas';
import { Quiz } from '@/pages/Quiz/Quiz';
import { Aula } from '@/pages/Aula/Aula';
import { ClasesHoy } from '@/pages/ClasesHoy/ClasesHoy';
import { Informes } from '@/pages/Informes/Informes';
import { AlumnoTracking } from '@/pages/Informes/AlumnoTracking';
import { AdminEmails } from '@/pages/AdminEmails/AdminEmails';
import { AppLayout } from '@/components/organisms/AppLayout';
import { ProtectedRoute } from './ProtectedRoute';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/',                element: <Navigate to="/inicio" replace /> },
          { path: '/inicio',          element: <Dashboard /> },
          { path: '/reservas',        element: <Reservas /> },
          { path: '/disponibilidad',  element: <Disponibilidad /> },
          { path: '/lecciones',                element: <ModulesList /> },
          { path: '/lecciones/modulo/:id',     element: <ModuleDetail /> },
          { path: '/lecciones/leccion/:id',    element: <LessonDetail /> },
          { path: '/grammar-bank',             element: <GrammarBankArchive /> },
          { path: '/grammar-bank/:slug',       element: <GrammarBankDetail /> },
          { path: '/mis-notas',                element: <MisNotas /> },
          { path: '/mis-feedbacks',            element: <MisFeedbacks /> },
          { path: '/mis-feedbacks/:bookingId', element: <FeedbackDetail /> },
          { path: '/profesor/feedbacks',       element: <ProfeFeedbacks /> },
          { path: '/quiz/:id',                 element: <Quiz /> },
          { path: '/aula',                     element: <ClasesHoy /> },
          { path: '/aula/:bookingId',          element: <Aula /> },
          { path: '/informes',                 element: <Informes /> },
          { path: '/informes/alumno/:id',      element: <AlumnoTracking /> },
          { path: '/perfil',          element: <Perfil /> },
          { path: '/admin/usuarios',   element: <AdminUsuarios /> },
          { path: '/admin/vocabulary', element: <AdminVocabulary /> },
          { path: '/admin/emails',     element: <AdminEmails /> },
        ],
      },
    ],
  },
]);
